import axios from 'axios';

// Adaptez cette URL selon votre configuration
// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5282/api';
const API_URL = 'https://resolvebo.innovationcode.pro/api';

const validationService = {
    /**
     * Valide un formulaire en utilisant les règles de validation dynamiques du backend
     * @param {Object} formData - Les données du formulaire à valider
     * @returns {Promise<Object>} - Retourne un objet contenant les erreurs
     */
    // src/services/validationService.js
    validateForm: async (formData) => {
        try {
            // Préparer les données
            const dataToValidate = { ...formData };
            console.log("Données envoyées pour validation:", dataToValidate);

            // Conversion de 'oui'/'non' en booléen
            // if (dataToValidate.isRelance) {
            //     dataToValidate.isRelance = dataToValidate.isRelance === 'oui';
            // }

            // Supprimer les champs qui ne doivent pas être validés
            delete dataToValidate.emailConfirm;

            try {
                // Tenter d'appeler l'API de validation
                await axios.post(`${API_URL}/ValidationRules/validate`, dataToValidate);
                // Si on arrive ici sans erreur, le formulaire est valide
                return {};
            } catch (error) {
                // Si l'API retourne des erreurs de validation (code 400)
                if (error.response && error.response.status === 400 && error.response.data) {
                    console.log("Erreurs de validation reçues:", error.response.data);

                    // Normaliser les noms de champs (première lettre en minuscule)
                    const normalizedErrors = {};
                    Object.entries(error.response.data).forEach(([key, value]) => {
                        // Convertir la première lettre en minuscule
                        const normalizedKey = key.charAt(0).toLowerCase() + key.slice(1);
                        normalizedErrors[normalizedKey] = value;
                    });

                    console.log("Erreurs normalisées:", normalizedErrors);
                    return normalizedErrors;
                }

                // Pour les autres types d'erreurs
                throw new Error("Erreur lors de la communication avec le serveur");
            }
        } catch (error) {
            console.error("Erreur technique:", error);
            throw error;
        }
    },

    /**
     * Combine les résultats de validation statique et dynamique
     * @param {Object} staticErrors - Erreurs du validateur local
     * @param {Object} dynamicErrors - Erreurs du validateur dynamique
     * @returns {Object} - Erreurs combinées
     */
    combineValidationResults: (staticErrors, dynamicErrors) => {
        // Fusionner les deux objets d'erreurs
        return { ...staticErrors, ...dynamicErrors };
    }
};

export default validationService;